/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Timeline Add component
 * @author Willem Jan Weitering

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["input[_ngcontent-%COMP%]{margin-bottom:.25rem}"];
export { styles as styles };
